// 1 ) Objeto que se va guardar en el contexto 

const initialState = {
    open: false,
    severity: "error",
    mensaje: [""]
};

// 2 ) Logica de manejo de la variable 
const openSnackbarReducer = (state = initialState, action) => {
    switch (action.type) {
        case "OPEN_SNACKBAR":
            return {
                ...state,
                open: action.openMensaje.open,
                severity: action.openMensaje.severity,
                mensaje: action.openMensaje.mensaje
            }
        default: return state;
    }
};

//3 se exporta el comporamiento que administra la variable pra poder usarse 

export default openSnackbarReducer;